import { apiService } from "@/services/apiService";
import { endpoints } from "@/config/endpoints";

export default {
  fetchExternalChanges({
    page,
    perPage,
    facilitiesIds,
    statuses,
    source,
    fields = []
  }) {
    const params = {
      page: page || 1,
      page_size: perPage,
      facilities_ids: facilitiesIds.join(","),
      status: statuses.join(","),
      source
    };
    // Only narrow by field when a subset is selected; absence of the param means "all fields".
    if (fields && fields.length) {
      params.field = fields.join(",");
    }
    return apiService.get(endpoints.gmbExternalChanges, { params });
  },
  updateExternalChanges({ changeId, status }) {
    const payload = {
      status
    };
    return apiService.patch(endpoints.gmbExternalChange(changeId), payload);
  },
  groupUpdateExternalChanges({ facilitiesIds, fields, status, source }) {
    const payload = {
      facilities_ids: facilitiesIds,
      fields,
      status
    };

    if (source !== null) {
      payload.source = source;
    }

    return apiService.patch(endpoints.gmbExternalChangesGroupAction, payload);
  },
  fetchExternalChangesSettings() {
    return apiService.get(endpoints.gmbExternalChangesSettings);
  },
  updateExternalChangesSettings({ id, form }) {
    return apiService.put(endpoints.updateGmbExternalChangesSettings(id), form);
  },

  getProtectionSummary() {
    return apiService.get(endpoints.gmbExternalChangesProtectionSummary);
  },

  rejectChanges(ids) {
    return apiService.post(endpoints.gmbExternalChangesReject, {
      gmb_external_changes_ids: ids
    });
  }
};
